/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LogEntry } from '../Models';
/**
 * LogsApi - axios parameter creator
 */
export const LogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogsContentContentIdGet: async (contentId: string, limit?: number, includeDebug?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contentId' is not null or undefined
            assertParamExists('apiLogsContentContentIdGet', 'contentId', contentId)
            const localVarPath = `/api/logs/content/{contentId}`
                .replace('{contentId}', encodeURIComponent(String(contentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeDebug !== undefined) {
                localVarQueryParameter['includeDebug'] = includeDebug;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {string} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogsGet: async (limit?: number, includeDebug?: boolean, tags?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (includeDebug !== undefined) {
                localVarQueryParameter['includeDebug'] = includeDebug;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogsApi - functional programming interface
 */
export const LogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogsContentContentIdGet(contentId: string, limit?: number, includeDebug?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogsContentContentIdGet(contentId, limit, includeDebug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiLogsContentContentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {string} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogsGet(limit?: number, includeDebug?: boolean, tags?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogsGet(limit, includeDebug, tags, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogsApi.apiLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogsApi - factory interface
 */
export const LogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} contentId 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogsContentContentIdGet(contentId: string, limit?: number, includeDebug?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogEntry>> {
            return localVarFp.apiLogsContentContentIdGet(contentId, limit, includeDebug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {boolean} [includeDebug] 
         * @param {string} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogsGet(limit?: number, includeDebug?: boolean, tags?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogEntry>> {
            return localVarFp.apiLogsGet(limit, includeDebug, tags, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogsApi - object-oriented interface
 */
export class LogsApi extends BaseAPI {
    /**
     * 
     * @param {string} contentId 
     * @param {number} [limit] 
     * @param {boolean} [includeDebug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLogsContentContentIdGet(contentId: string, limit?: number, includeDebug?: boolean, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiLogsContentContentIdGet(contentId, limit, includeDebug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {boolean} [includeDebug] 
     * @param {string} [tags] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLogsGet(limit?: number, includeDebug?: boolean, tags?: string, options?: RawAxiosRequestConfig) {
        return LogsApiFp(this.configuration).apiLogsGet(limit, includeDebug, tags, options).then((request) => request(this.axios, this.basePath));
    }
}

